export * from './jatak.interface';
